"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const PublisherContactCondensed = (props) => (react_1.default.createElement("div", { className: 'contact-details-expanded' },
    props.showHfa && (react_1.default.createElement("div", { className: "details-container" },
        react_1.default.createElement("p", { className: "small-2" }, "212-834-0100"),
        react_1.default.createElement("p", { className: "small-2" }, "licensing@harryfox.com"),
        react_1.default.createElement("p", { className: 'small-2 address' },
            "HFA",
            react_1.default.createElement("br", null),
            "40 Wall Street",
            react_1.default.createElement("br", null),
            "New York, NY 10005"))),
    !props.showHfa && (react_1.default.createElement("div", { className: "details-container" },
        props.data.email && react_1.default.createElement("p", { className: "small-2" }, props.data.email),
        props.data.website && (react_1.default.createElement("p", { className: "small-2" },
            react_1.default.createElement("a", { href: props.data.website, target: "_blank", rel: "noreferrer" }, props.data.website)))))));
exports.default = PublisherContactCondensed;
